import { type CardSize } from '@air/api/types';

/**
 * @TODO - Design team will provide the correct sizes for each card size
 */
export const FILE_CARD_SIZES: { [key in CardSize]: number } = {
  small: 196,
  medium: 196,
  large: 196,
  'extra-large': 196,
};

export const DEFAULT_BOARD_CARD_SIZE = {
  height: 192,
  width: 192,
};

export const GALLERY_CARD_SIZES: Record<CardSize, { height: number; width: number }> = {
  small: { height: 160, width: 160 },
  medium: { height: 192, width: 192 },
  large: { height: 256, width: 256 },
  'extra-large': { height: 320, width: 320 },
};

export const LIBRARY_BOARD_CARD_SIZES: Record<CardSize, { height: number; width: number }> = {
  small: { height: 174, width: 260 },
  medium: { height: 174, width: 320 },
  large: { height: 174, width: 400 },
  'extra-large': { height: 174, width: 480 },
};
